/**
 * AI Garage Form Options
 * Centralized constants for all dropdown options used in tool and maker forms
 */

// Target Roles - Used in Matrix View
export const ROLE_OPTIONS = [
  'Leadership',
  'AE',
  'SE',
  'CSM',
  'TAM',
  'BDR',
  'Channel Manager'
];

// Customer Journey Stages - Used in Matrix View
export const JOURNEY_OPTIONS = [
  'Prospect',
  'Qualify',
  'Demo/Eval',
  'Proposal',
  'Onboard',
  'Expand',
  'Adopt',
  'Retain',
  'Backstage'
];

// Personas - Used in Matrix View
export const PERSONA_OPTIONS = [
  'Sales',
  'Customer Success',
  'Product',
  'IT',
  'Engineering',
  'Marketing',
  'Finance',
  'Support',
  'Operations',
  'HR'
];

// Sales Stages (lowercase version)
export const SALES_STAGE_OPTIONS = [
  'qualify',
  'demo',
  'proposal',
  'onboard',
  'expand',
  'retain'
];

// Tool Tags/Categories
export const TAG_OPTIONS = [
  'Productivity',
  'Sales',
  'Customer Success',
  'AI',
  'Automation',
  'Analysis',
  'Reporting',
  'Communication',
  'Integration',
  'Data',
  'Research',
  'Forecasting',
  'QBR',
  'Account Planning',
  'Deal Desk',
  'Competitive Intelligence'
];

// Integrations
export const INTEGRATION_OPTIONS = [
  'SFDC',
  'Salesforce',
  'Gainsight',
  'Snowflake',
  'DocuSign',
  'Gong',
  'Outreach',
  'LinkedIn Sales Navigator',
  'Slack',
  'Zoom',
  'Microsoft Teams',
  'Google Workspace',
  'Confluence',
  'Jira',
  'HubSpot',
  'Marketo'
];

// Environments
export const ENVIRONMENT_OPTIONS = [
  'PRD',
  'DEV',
  'TEST',
  'STAGING',
  'N/A'
];

// AI Models
export const MODEL_OPTIONS = [
  'GPT-4',
  'GPT-4 Turbo',
  'GPT-3.5',
  'Claude',
  'Claude Sonnet',
  'Claude Opus',
  'Gemini',
  'Gemini Pro',
  'N/A',
  'Custom'
];

// Capabilities - Used in Matrix View
export const CAPABILITY_OPTIONS = [
  'Research',
  'Generate',
  'Analyze',
  'Calculate',
  'Automate',
  'Visualize'
];

// Maker Focus Areas
export const FOCUS_AREA_OPTIONS = [
  'AI/ML',
  'Sales Tools',
  'Customer Success',
  'Data Analysis',
  'Automation',
  'Integration',
  'UI/UX',
  'Backend',
  'Frontend',
  'DevOps',
  'Product Management'
];

// Departments
export const DEPARTMENT_OPTIONS = [
  'Sales',
  'Customer Success',
  'Product',
  'Engineering',
  'Marketing',
  'Finance',
  'IT',
  'Operations',
  'HR',
  'Legal'
];

// Tool Types
export const TOOL_TYPE_OPTIONS = [
  'App',
  'Gem'
];

// Tool Status
export const STATUS_OPTIONS = [
  'draft',
  'published',
  'pending',
  'rejected',
  'archived'
];

// Access roles for user management (garage_user_profiles.role)
export const ACCESS_ROLE_OPTIONS = [
  { value: 'user', label: 'User' },
  { value: 'analyst_reviewer', label: 'Analyst & Reviewer' },
  { value: 'persona_admin', label: 'Persona Admin' },
  { value: 'admin', label: 'Admin (Full Access)' },
];

export const ACCESS_ROLE_LABELS = ACCESS_ROLE_OPTIONS.reduce((acc, role) => {
  acc[role.value] = role.label;
  return acc;
}, {});
